import { Stack, Typography } from '@mui/material';

import { useAppForm } from '@/hooks/useAppForm';
import { useNavigationBlocker } from '@/hooks/useNavigationBlocker';
import { I18N_DE } from '@/i18n/de';
import type { OrganizationUser, UpdateOrganizationUserDto } from '@/modules/api/backend';
import { formScrollIntoViewOptions } from '@/utils/formScrollIntoViewOptions';

interface EditOrganizationUserFormProps {
  initialValues: OrganizationUser;
  onSubmit: (values: UpdateOrganizationUserDto) => Promise<void>;
}

export function EditOrganizationUserForm({ initialValues, onSubmit }: EditOrganizationUserFormProps) {
  const form = useAppForm({
    defaultValues: { role: initialValues.role },
    ...formScrollIntoViewOptions,
    onSubmit: async ({ value }) => {
      form.reset();

      await onSubmit(value);
    },
  });

  useNavigationBlocker(form);

  return (
    <form
      id="organizationUserForm"
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Stack
        spacing={2}
        sx={{
          py: { sm: 1, md: 0 },
        }}
      >
        <Typography variant="h2">User*in</Typography>

        <form.AppField name="role">
          {(field) => (
            <field.SelectField
              label="Rolle"
              options={Object.entries(I18N_DE.OrganizationUserRole).map(([value, label]) => ({
                value,
                label,
              }))}
            />
          )}
        </form.AppField>
      </Stack>
    </form>
  );
}
